import {
  PrimaryTextColor,
  getRelativeFontSize,
  heading,
  mediumFont,
  primarySteperColor,
  primaryWhiteColor,
  regularFont,
  subHeading,
} from "../../../../utils/styles";

const MyProfileViewStyles = {
  headerWrapper: {
    padding: "0 20px",
  },

  profileWrapper: {
    width: "100%",
  },

  stepperStyle: {
    marginLeft: 14,
    marginTop: 5,
    "& .MuiStepConnector-root": {
      marginLeft: 2.7,
      borderLeft: "1px solid #9E9FAB",
    },
  },

  label: {
    ...regularFont,
    fontSize: getRelativeFontSize(-2),
    marginLeft: "10px",
    width: "70px",
    "&:hover": {
      cursor: "pointer !important",
    },
  },

  stepLabel: {
    "& 	.MuiStepIcon-root": {
      width: "32px",
      height: "32px",
      border: "6px solid",
      borderColor: primaryWhiteColor,
      boxShadow: `0 0 0 3.5px ${"#9E9FAB"}`,
      borderRadius: "50%",
      ...regularFont,
      "&:hover": {
        cursor: "pointer !important",
      },
    },

    "& .css-1u4zpwo-MuiSvgIcon-root-MuiStepIcon-root.Mui-completed": {
      color: "#646DEA",
      boxShadow: "0 0 0 3.5px #646DEA",
    },

    "& .css-14pf2dw-MuiStepLabel-root .MuiStepIcon-root": {
      boxShadow: `0 0 0 3.5px ${primarySteperColor}`,
    },

    "& .css-1u4zpwo-MuiSvgIcon-root-MuiStepIcon-root.Mui-active": {
      color: primarySteperColor,
      borderColor: primaryWhiteColor,
      boxShadow: `0 0 0 3px ${primarySteperColor}`,
    },

    "& .css-1c98z7n-MuiStepLabel-label.Mui-active": {
      color: "#646DEA",
    },

    "& .css-1c98z7n-MuiStepLabel-label.Mui-completed ": {
      color: "#646DEA",
    },
  },
};

export default MyProfileViewStyles;
